import { render, staticRenderFns } from "./footBottom.vue?vue&type=template&id=5f34ba25&"
import script from "./footBottom.vue?vue&type=script&lang=js&"
export * from "./footBottom.vue?vue&type=script&lang=js&"
import style0 from "./footBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports